import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { LanguageService, ENGLISH, SWEDISH } from '../../../core/service/language.service';

@Component({
    selector: 'app-send-registration-key-form',
    templateUrl: './send-registration-key-form.component.html',
    styleUrls: ['./send-registration-key-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendRegistrationKeyFormComponent implements OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _controlModelFactory: FormControlExFactory,
    private _fb: FormBuilder,
    private _languageService: LanguageService,
    @Inject('defaultEmail') defaultEmail: string
  ) {
    if (defaultEmail) this._defaultEmail = defaultEmail;
  }

  private _defaultEmail: string;
  form: FormGroup;
  languages: { name: string; value: string }[];

  cancel() {
    this._actionService.close();
  }

  ngOnInit() {
    this.languages = [
      { name: 'ENGLISH_TEXT', value: ENGLISH },
      { name: 'SWEDISH_TEXT', value: SWEDISH },
    ];
    const lang = this.languages.find(x => x.value === this._languageService.currentLanguage);
    this.form = this._fb.group({
      email: this._controlModelFactory.createEmail('SEND_REGISTRATION_KEY_FORM.EMAIL_LABEL', this._defaultEmail),
      language: this._controlModelFactory.create('LANGUAGE_TEXT', lang.value),
    });
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.form.value.language = this._languageService.getLanguageId(this.form.value.language);
    this._actionService.complete(this.form.value);
  }
}
